import { h, svgUse } from '../../../utils/dom.js';

export function AvatarMenu({ onGoProfile } = {}) {
  const btn = h('button', {
    class: 'avatar-btn',
    'aria-label': 'user menu',
    onclick: (e) => {
      e.stopPropagation();
      if (onGoProfile) onGoProfile();
    },
  },
    h('div', { class: 'avatar-circle' }, svgUse('ic-user')),
    svgUse('ic-chev', 'chev')
  );

  const el = h('div', { class: 'avatar-wrap' }, btn);
  return { el };
}
